import React, { useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import ModalAvertissement from "./ModalAvertissement";

import { useToasts } from "react-toast-notifications";
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";

const API_URL = process.env.REACT_APP_API_URL;

function NotesMutuelle(props) {
  const [show, setShow] = useState(false);
  const setRefresh = props.setRefresh;
  const refresh = props.refresh;
  const [newNote, setNewNote] = useState();
  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);
  const mutuelleId = props.mutuelleId;
  const loggedIn = useSelector((state) => state.login);
  const { addToast } = useToasts();
  const [showAvertissement, setShowAvertissement] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowAvertissement = () => setShowAvertissement(true);
  const handleChange = (content) => {
    setNewNote(content);
  };
  function handleSubmit() {
    axios
      .put(
        `${API_URL}/api/notes/mutuelle/${mutuelleId}`,
        { newNote },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        addToast("Note enregistrée !", {
          appearance: "success",
          autoDismiss: true,
        });
        setNewNote();
        setRefresh(!refresh);
      })
      .catch((e) => {
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  }

  return (
    <div>
      <MDBBtn
        color="primary"
        onClick={loggedIn ? handleShow : handleShowAvertissement}
      >
        Modifier
      </MDBBtn>
      <MDBModal isOpen={show} size="lg" onHide={handleClose}>
        <MDBModalHeader>Notes</MDBModalHeader>
        <MDBModalBody>
          <SunEditor
            lang="fr"
            width="100%"
            height="400px"
            autoFocus={true}
            setContents={props.notes}
            setOptions={{
              buttonList: [
                ["bold", "underline", "italic"],
                ["fontColor", "hiliteColor"],
                ["removeFormat"],
                ["horizontalRule"],
                ["link"],
              ],
              showPathLabel: false,
              resizingBar: false,
            }}
            onChange={handleChange}
          />
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn outline color="primary" onClick={handleClose}>
            Fermer
          </MDBBtn>
          <MDBBtn
            color="primary"
            onClick={() => {
              handleSubmit();
              handleClose();
            }}
          >
            Ajouter
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
      <ModalAvertissement
        showAvertissement={showAvertissement}
        setShowAvertissement={setShowAvertissement}
      />
    </div>
  );
}

export default NotesMutuelle;
